import { useEffect, useState } from 'react';

import Button from 'components/shared/Button/Button';

const AddProviderFooter = ({ selectionCountRef, onClose, isInNetworkTab, onSubmit }) => {
  const [selectionCount, setSelectionCount] = useState(0);

  useEffect(() => {
    selectionCountRef.current = setSelectionCount;

    return () => {
      selectionCountRef.current = null;
    };
  }, [selectionCountRef]);

  return (
    <>
      <Button text="Close" size="small" style="outlined" color="neutral" onClick={onClose} />
      <Button
        text={`Add ${isInNetworkTab ? 'in-network' : 'out-of-network'} providers`}
        size="small"
        onClick={onSubmit}
        isDisabled={selectionCount === 0}
      />
    </>
  );
};

export default AddProviderFooter;
